export default __webpack_public_path__ + "images/success.0e79a756efc49c2401c27a3a42d16f77.svg";